module.exports = __webpack_public_path__ + "static/media/no-data.265cf37e.jpg";